module.exports = __webpack_public_path__ + "img/avatar-female.3119aa06.png";